import type { BasicBoxProps, MeasurementProps } from '@/components/boxes/measurementBoxes/types.ts';
import type { SceneItemKind, SplineItems } from '@/engine/app/interfaces.ts';

export type SplineAreaMeasurementBoxProps = BasicBoxProps<MeasurementProps>;

export interface ISplineItemConfig {
  label: string;
  splineItem: SplineItems;
  labelKey: string;
  measurementKey: string;
  valueKey: AreaValueType;
  unitOfMeasurement: 'mm' | 'mm²';
}

export interface IWideAreaMeasurementConfigStrategy {
  getConfigByMeasurementSceneItemKind: (kind: SceneItemKind) => Array<ISplineItemConfig> | undefined;
}

export enum AreaValueType {
  area = 'area',
  dMin = 'dMin',
  dMax = 'dMax',
  dMean = 'dMean',
  perimeter = 'perimeter',
  pdDiameter = 'dP',
  dX = 'dX',
  dY = 'dY'
}
